// @core/stores/booking/BookingWaitlistStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { bookingApi } from '@core/api';
import type {
  AcceptWaitlistOfferRequest,
  BookingResponse,
  JoinWaitlistRequest,
  ListWaitlistEntriesResponse,
  WaitlistEntryResponse,
} from '@core/types/booking';

class BookingWaitlistStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Accept waitlist offer
   */
  async AcceptWaitlistOffer(entry_id: string, data: AcceptWaitlistOfferRequest): Promise<BookingResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.AcceptWaitlistOffer(entry_id, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Join waitlist
   */
  async JoinWaitlist(resource_id: string, data: JoinWaitlistRequest): Promise<WaitlistEntryResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.JoinWaitlist(resource_id, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Leave waitlist
   */
  async LeaveWaitlist(entry_id: string): Promise<Response> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.LeaveWaitlist(entry_id);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * List waitlist entries
   */
  async ListWaitlistEntries(resource_id: string, params?: { limit?: string | number | boolean; cursor?: string | number | boolean; direction?: string | number | boolean; sort?: string | number | boolean; }): Promise<ListWaitlistEntriesResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.ListWaitlistEntries(resource_id, params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const bookingWaitlistStore = new BookingWaitlistStore();
